import { LOAN_APPLICATION_STATUS, USER_ROLES } from "../../constants/appConstants";
import { Strings } from "../../resources/i18n/i18n";
import { LOAN_TYPES } from "../AnalystApproval/Constants";

export const REFERENCES_FIELDS = [
    { key: "name", name: "name", type: "text", isMandatory: true, },
    { key: "address", name: "address", type: "text", isMandatory: false, },
    { key: "phone", name: "phone", type: "number", isMandatory: true, maxLength: 10 },
];
export const NON_MANDATORY_REFERENCES_FIELDS = [
    { key: "name", name: "name", type: "text", isMandatory: false, },
    { key: "address", name: "address", type: "text", isMandatory: false, },
    { key: "phone", name: "phone", type: "number", isMandatory: false, maxLength: 10 },
]
export const LOAN_STEPS = {
    BASIC_INFORMATION : "BASIC_INFO",
    INCOME : "INCOME",
    EXPENSES : "EXPENSES",
    SITE_VISIT : "SITE_VISIT",
    DOCUMENTS : "DOCUMENTS",
}
export const loanApplicationFormInputs = {
    creditProduct: [
        {
            key: "amount",
            label: "Amt",
            className: "",
            isEdit: false,
            type: "number",
            isSelection: false,
            isNumber: true,
            visibleForLoanTypes: [LOAN_TYPES.FACTORING, LOAN_TYPES.MOTORCYCLE_LOAN, LOAN_TYPES.CONSUMER, LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.CASH_TOPUP, LOAN_TYPES.TU_PRESTAMO, LOAN_TYPES.PREMIUM_CASH_TOPUP, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "",
        },
        {
            key: "businessName",
            label: "businessName",
            className: "",
            isEdit: false,
            type: "select",
            isSelection: true,
            isNumber: true,
            visibleForLoanTypes: [LOAN_TYPES.EXTERNAL_FACTORING],
            dropdownListKey: "businessNameList",

        },
        {
            key: "selectedDisbursementType",
            label: "sdt",
            className: "",
            isEdit: false,
            type: "select",
            isSelection: true,
            isNumber: false,
            visibleForLoanTypes: [LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "disbursementTypeList",
        },
        {
            key: "selectedTransferAccountType",
            label: "stat",
            className: "",
            isEdit: false,
            type: "select",
            isSelection: true,
            isNumber: false,
            visibleForLoanTypes: [LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "transferAccountTypeList",
        },
        {
            key: "bankName",
            label: "bankName",
            className: "",
            isEdit: false,
            type: "select",
            isSelection: true,
            isNumber: false,
            visibleForLoanTypes: [LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "bankNameList",
        },
        {
            key: "accountType",
            label: "accountType",
            className: "",
            isEdit: false,
            type: "select",
            isSelection: true,
            isNumber: false,
            visibleForLoanTypes: [LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "accountTypeList",
        },
        {
            key: "accountNumber",
            label: "accountNumber",
            className: "",
            isEdit: false,
            type: "number",
            isSelection: false,
            isNumber: true,
            visibleForLoanTypes: [LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "",
        },
        {
            key: "frequency",
            label: "frequency",
            className: "",
            isEdit: false,
            type: "select",
            isSelection: true,
            isNumber: false,
            visibleForLoanTypes: [LOAN_TYPES.FACTORING, LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.CASH_TOPUP, LOAN_TYPES.CONSUMER, LOAN_TYPES.MOTORCYCLE_LOAN, LOAN_TYPES.TU_PRESTAMO, LOAN_TYPES.PREMIUM_CASH_TOPUP, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "frequencyList",
        },
        {
            key: "collectionDays",
            label: "collectionDays",
            className: "",
            isEdit: false,
            type: "select",
            isSelection: true,
            isNumber: false,
            visibleForLoanTypes: [LOAN_TYPES.FACTORING, LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.CASH_TOPUP, LOAN_TYPES.CONSUMER, LOAN_TYPES.MOTORCYCLE_LOAN, LOAN_TYPES.TU_PRESTAMO, LOAN_TYPES.PREMIUM_CASH_TOPUP, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "collectionDaysList",
        },
        {
            key: "term",
            label: "term",
            className: "",
            isEdit: false,
            type: "select",
            isSelection: true,
            isNumber: false,
            visibleForLoanTypes: [LOAN_TYPES.FACTORING, LOAN_TYPES.EXTERNAL_FACTORING, LOAN_TYPES.CASH_TOPUP, LOAN_TYPES.CONSUMER, LOAN_TYPES.MOTORCYCLE_LOAN, LOAN_TYPES.TU_PRESTAMO, LOAN_TYPES.PREMIUM_CASH_TOPUP, LOAN_TYPES.PERSONAL_LOAN],
            dropdownListKey: "termsArrayList",
        },
    ],
    basicInfo: {
        businessInfo: [
            { key: "businessType", name: "businessType", type: "select", isMandatory: true, isSelection: true, dropdownListKey: "" },
            { key: "ciCustomerSinceYears", name: "ciCustomerSinceYears", type: "select", isMandatory: true, isSelection: true, dropdownListKey: "" },
            { key: "businessEstablishedSinceYears", name: "businessEstablishedSinceYears", type: "select", isMandatory: true, isSelection: true, dropdownListKey: "" },
            { key: "telephone", name: "ColmadoTelephone", type: "number", isMandatory: true, maxLength: 10, isSelection: false, dropdownListKey: "" },
            { key: "ciCreditLimit", name: "supplierCreditLimit", type: "number", isMandatory: true, maxLength: 30, isSelection: false, dropdownListKey: "" },
            { key: "holder", name: "holder", type: "select", isMandatory: true, maxLength: 30, isSelection: true, dropdownListKey: "" },
        ],
        ownerInfo: [
            { key: "ownerName", name: "NameOfOwner", type: "text", isMandatory: true, maxLength: 50, isSelection: false, dropdownListKey: "" },
            { key: "ownerId", name: "IDOfOwner", type: "number", isMandatory: true, maxLength: 11, isSelection: false, dropdownListKey: "" },
            { key: "ownerNumber", name: "ownerNumber", type: "number", isMandatory: true, maxLength: 10, isSelection: false, dropdownListKey: "" },
            { key: "ownerAddress", name: "ownerAddress", type: "text", isMandatory: true, maxLength: 200, isSelection: false, dropdownListKey: "" },
            { key: "ownerDateOfBirth", name: "ownerDateOfBirth", isDate: "date", isAfter: true, validateBirthdate: true, isMandatory: true, isSelection: false, dropdownListKey: "" },
            { key: "ownerHomeType", name: "ownerHomeType", type: "select", isMandatory: true, isSelection: true, dropdownListKey: "" },
            { key: "homeLocation", name: "homeLocation", type: "select", isMandatory: true, isSelection: true, dropdownListKey: "" },
            { key: "familyMembers", name: "familyMembers", type: "select", isMandatory: true, isSelection: true, dropdownListKey: "" },
            { key: "numberOfVehicles", name: "numberOfVehicles", type: "select", isMandatory: true, isSelection: true, dropdownListKey: "" },
            { key: "bankDetail", name: "bankDetail", type: "text", isMandatory: false, isSelect: "multiSelect", isSelection: false, dropdownListKey: "" },
            { key: "remittanceDetails", name: "remittanceDetails", type: "select", isMandatory: false, isSelection: true, dropdownListKey: "" },
            { key: "socialMediaAccountDetails", name: "socialMediaAccountDetails", type: "text", isMandatory: false, isSelect: "multiSelect", isSelection: false, dropdownListKey: "" },
        ],
        adminInfo: [
            { key: "adminName", name: "adminName", type: "text", isMandatory: false, maxLength: 50, isSelection: false, dropdownListKey: "" },
            { key: "adminId", name: "adminId", type: "number", isMandatory: false, maxLength: 11, isSelection: false, dropdownListKey: "" },
            { key: "adminDateOfBirth", name: "adminDateOfBirth", isDate: "date", isAfter: true, validateBirthdate: true, isMandatory: false, isSelection: false, dropdownListKey: "" },
            { key: "adminNumber", name: "adminNumber", type: "number", isMandatory: false, maxLength: 10, isSelection: false, dropdownListKey: "" },
            { key: "adminSince", name: "adminSince", type: "select", isMandatory: false, isSelection: true, dropdownListKey: "" },
            { key: "adminAddress", name: "adminAddress", type: "text", isMandatory: false, maxLength: 200, isSelection: false, dropdownListKey: "" },
            { key: "adminSalary", name: "adminSalary", type: "select", isMandatory: false, isSelection: true, dropdownListKey: "" }
        ],

    },
    references: {
        comercialRef1: REFERENCES_FIELDS,
        comercialRef2: REFERENCES_FIELDS,
        personalRef1: REFERENCES_FIELDS,
        personalRef2: NON_MANDATORY_REFERENCES_FIELDS,
        neighbourhoodRef1: REFERENCES_FIELDS,
        neighbourhoodRef2: NON_MANDATORY_REFERENCES_FIELDS,
    },
    financialInformation: [
        {
            name: Strings("monthlySalesAmount") + "($)",
            personalLoanName: Strings("monthlySalary") + "($)",
            key: "monthlySalesAmount",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("accountsPending"),
            personalLoanName: Strings("outstandingDebts"),
            key: "accountsPending",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("inventory"),
            personalLoanName: Strings("otherIncome"),
            key: "inventory",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
    ],
    expenses: [
        {
            name: Strings("numberOfEmployees"),
            key: "numberOfEmployees",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("salaryOfEmployees") + "($)",
            key: "salaryOfEmployees",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("rent") + "($)",
            key: "rent",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("electricity"),
            key: "electricity",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("telephone"),
            key: "telephone",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("CableInternet"),
            key: "internet",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("GasOfDelivery"),
            key: "gas",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("waterConnection"),
            key: "water",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("DebtsToSuppliers"),
            key: "debtsToSuppliers",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
    ],
    siteVisit: [
        {
            name: Strings("NoOfOwnedDeliveryMotors"),
            key: "numberOfMotors",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("NoOfExhibitors"),
            key: "numberOfExhibitors",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("NoOfBotellero"),
            key: "numberOfBotellero",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("NoOfCars"),
            key: "numberOfCars",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("NoOfTV"),
            key: "numberOfTVs",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("NoOfTelephone"),
            key: "numberOfTelephones",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("NoOfFreezers"),
            key: "numberOfFreezers",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("NoOfExhibitionFridges"),
            key: "numberOfFridges",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("localType"),
            key: "localType",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: Strings("roofType"),
            key: "roofType",
            type: "select",
            isMandatory: true,
            isSelection: true,
        },
        {
            name: null,
            key: "investor",
            type: "select",
            isMandatory: false,
            isSelection: false,
        },
    ]
}

export const PERSONAL_LOAN_FIELD_OVERRIDES = {
    // businessInfo overrides
    businessEstablishedSinceYears: { labelKey: "employmentDuration" },
    telephone: { labelKey: "homePhone" },
    ciCustomerSinceYears: { hidden: true },
    ciCreditLimit: { hidden: true },
    holder: { hidden: true },
    // ownerInfo overrides
    ownerName: { labelKey: "customerName" },
    ownerId: { labelKey: "customerId" },
    ownerNumber: { labelKey: "customerMobileNumber" },
    ownerAddress: { labelKey: "customerAddress" },
    ownerDateOfBirth: { labelKey: "customerDateOfBirth" },
    homeLocation: { hidden: true },
    // adminInfo overrides
    adminName: { labelKey: "companyName" },
    adminId: { labelKey: "companyRNC" },
    adminDateOfBirth: { hidden: true },
    adminNumber: { labelKey: "companyPhoneNumber" },
    adminSince: { labelKey: "employmentDuration" },
    adminAddress: { labelKey: "companyAddress" },
    adminSalary: { labelKey: "salary" },
    // financialInformation (income) overrides — used by the loan details view.
    // The create flow renders these via the `personalLoanName` field above.
    monthlySalesAmount: { labelKey: "monthlySalary" },
    accountsPending: { labelKey: "outstandingDebts" },
    inventory: { labelKey: "otherIncome" },
};

export const PHOTO_UPLOAD_LIMITS = {
    LOCAL_PHOTO: 5,
    INVOICE: 3,
    PHOTOID: 2,
    EXTERNAL_INVOICE: 2
};
export const LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT = {
    LOAN_TYPE: "loanType",
    CREDIT_PRODUCTS: "creditProducts",
    BASIC_INFORMATION: "BasicInformation",
    REFERENCES: "References",
    FINANCIAL_INFORMATION: "FinancialInformation",
    SITE_VISIT: "SiteVisit",
    EVIDENCE: "Evidence",
    LOAN_INFO: "loanInfo",
    BASIC_INFO: "basicInfo",
    ADDITIONAL_INFO: "additionalInfo",
    INCOME: "income",
    SITEVISIT: "siteVisit",
    DOCUMENTS: "documents",
}
export const LOAN_CREATION_STEPS = [LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.LOAN_TYPE, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.CREDIT_PRODUCTS, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.BASIC_INFORMATION, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.REFERENCES, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.FINANCIAL_INFORMATION, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.SITE_VISIT, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.EVIDENCE];
export const LOAN_CREATION_STEPS_MAP = [LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.LOAN_TYPE, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.LOAN_INFO, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.BASIC_INFO, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.ADDITIONAL_INFO, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.INCOME, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.SITEVISIT, LOAN_CREATION_STEPS_AND_LOAN_DETAILS_OBJECT.DOCUMENTS];
export const INVOICE_COLUMNS = [
    { key: "select", name: Strings("select"), minWidth: 30, maxWidth: 30 },
    { key: "number", name: Strings("invoiceNumber"), minWidth: 100, maxWidth: 100 },
    { key: "date", name: Strings("invoiceDate"), minWidth: 160, maxWidth: 160 },
    { key: "expiryDate", name: Strings("expiryDate"), minWidth: 160, maxWidth: 160 },
    { key: "balance", name: Strings("amount") + " ($)", minWidth: 120, maxWidth: 120 },
    { key: "it", name: Strings("itemType"), minWidth: 100, maxWidth: 100 },
    { key: "tvd", name: Strings("truckVisitDay"), minWidth: 80, maxWidth: 80 },
];

export const MOTORCYCLE_LOAN = [
    { key: "select", name: Strings("select"), minWidth: 50, maxWidth: 50 },
    { key: "img", name: Strings("Image"), minWidth: 120, maxWidth: 120 },
    { key: "mn", name: Strings("motorcycleName"), minWidth: 180, maxWidth: 200 },
    { key: "mo", name: Strings("model"), minWidth: 160, maxWidth: 160 },
    { key: "co", name: Strings("price"), minWidth: 160, maxWidth: 160 },
];

export const PRODUCT_LOAN = [
    {
        key: "select",
        name: Strings("select"),
        minWidth: "10%",
        maxWidth: "10%"
    },
    {
        key: "category",
        name: Strings("Category"),
        minWidth: "15%",
        maxWidth: "15%",
    },
    {
        key: "productNameAndDescription",
        name: Strings("product"),
        minWidth: "50%",
        maxWidth: "50%",
    },
    {
        key: "model",
        name: Strings("model"),
        minWidth: "10%",
        maxWidth: "10%",
    },

    {
        key: "cost",
        name: Strings("cost"),
        minWidth: "13%",
        maxWidth: "20%"
    },
];
export const LOANS_WITH_TABLE_DATA = ["FACTORING", "CONSUMER", "MOTORCYCLE"];
export const PRODUCT_LOANS = ["CONSUMER", "MOTORCYCLE"]
export const columnMap = {
    [LOAN_TYPES.CONSUMER]: PRODUCT_LOAN,
    [LOAN_TYPES.MOTORCYCLE_LOAN]: MOTORCYCLE_LOAN,
    [LOAN_TYPES.FACTORING]: INVOICE_COLUMNS,
};
export const loanTypeLabelMap = {
    [LOAN_TYPES.CONSUMER]: 'Product',
    [LOAN_TYPES.MOTORCYCLE_LOAN]: 'Motorcycle',
    [LOAN_TYPES.FACTORING]: 'Invoice',
};
export const LOAN_STATUS = [
    "NEW",
    "IN_PROGRESS",
    "ASSIGNED",
]

export const TYPE_OF_ROLE = {
    nm: "typeOfRole",
    opt: ["OWNER", "ADMIN"]
}
export const EVIDENCE_SECTIONS_OBJECT = {
    LOCAL_PHOTO: "LOCAL_PHOTO",
    INVOICE: "INVOICE",
    EXTERNAL_INVOICE: "EXTERNAL_INVOICE",
    APPLICATION_SIGNATURE: "APPLICATION_SIGNATURE",
    PHOTOID_FRONT: "PHOTOID_FRONT",
    PHOTOID_BACK: "PHOTOID_BACK",
    PHOTOID: "PHOTOID",
}
export const REFERENCE_FIELDS_OBJECT = {
    COMMERCIAL_REF_1: "comercialRef1",
    COMMERCIAL_REF_2: "comercialRef2",
    PERSONAL_REF_1: "personalRef1",
    PERSONAL_REF_2: "personalRef2",
    NEIGHBOURHOOD_REF_1: "neighbourhoodRef1",
    NEIGHBOURHOOD_REF_2: "neighbourhoodRef2",
}
export const NON_MANDATORY_REFERENCE_FIELDS = ["personalRef2", "neighbourhoodRef2"];

export const API_CALL_NOT_ALLOWED_STATUS = [LOAN_APPLICATION_STATUS.created, LOAN_APPLICATION_STATUS.inProcess, LOAN_APPLICATION_STATUS.pending, LOAN_APPLICATION_STATUS.incomplete, LOAN_APPLICATION_STATUS.readyForCollection]

export const COMPULSORY_CREDIT_PRODUCT_FIELDS = ["amount", "frequency", "term", "collectionDays"]

export const ADMIN_FIELDS = ["adminName", "adminId", "adminDateOfBirth", "adminNumber", "adminSince", "adminAddress", "adminSalary"]

export const EVIDENCE_SECTIONS = [EVIDENCE_SECTIONS_OBJECT.LOCAL_PHOTO, EVIDENCE_SECTIONS_OBJECT.INVOICE, EVIDENCE_SECTIONS_OBJECT.EXTERNAL_INVOICE, EVIDENCE_SECTIONS_OBJECT.APPLICATION_SIGNATURE]

export const PHONE_FIELDS = ["ColmadoTelephone", "adminNumber", "ownerNumber"];

export const CEDULA_FIELDS = ["IDOfOwner", "adminId"];

export const LOAN_CREATION = "LOAN_CREATION";

export const ELIGIBLE_USER_ROLES = [USER_ROLES.generalManager, USER_ROLES.salesManager, USER_ROLES.salesModerator]